import React from 'react';
import { Button, Heading, Icon } from '@innovationnorway/cl-react';
import useReleaseNotes from 'src/hooks/use-release-notes';
import { formatDateToNOString } from 'src/utils/FormatValue';
import { useTranslation } from 'react-i18next';
import DocumentTitle from 'src/components/DocumentTitle/DocumentTitle';
import useDocumentTitle from 'src/hooks/use-document-title';
const ReleaseNotes = () => {
  const { releaseNotes, likeMutation } = useReleaseNotes();
  const { t: tCommon } = useTranslation('common');
  const { documentTitle } = useDocumentTitle(tCommon('releaseNotes'));
  return (
    <main className="full-width-layout stack">
      <DocumentTitle title={documentTitle} />
      <Heading level={1}>{tCommon('releaseNotes')}</Heading>
      {releaseNotes.map((note) => (
        <details className="legacy-details box" key={note.id}>
          <summary className=" background-color--blue-12">
            <Heading level={2} className="margin--0">
              {note.title}{' '}
              {formatDateToNOString(new Date(note.createdOn), false, '{date}.{month}.{year}', true)}{' '}
              <Icon prefix="fasr" iconName="angle-down" />
            </Heading>
          </summary>
          <div className="stack-medium padding--2">
            <p>{note.body}</p>
            <div className="display--flex gap--10">
              <Button
                type="button"
                variant="tertiary"
                aria-pressed={note.userHasLikedThisReleaseNote}
                onClick={() =>
                  likeMutation.mutateAsync({ id: note.id, likes: !note.userHasLikedThisReleaseNote })
                }
              >
                <Icon prefix={note.userHasLikedThisReleaseNote ? 'fass' : 'fasr'} iconName="thumbs-up" />
                {tCommon('releaseNotes.useful')}
              </Button>
              <p className="margin--0">
                {note.likes} {tCommon('releaseNotes.voted')}
              </p>
            </div>
          </div>
        </details>
      ))}
    </main>
  );
};
export default ReleaseNotes;
